import React, { useState } from "react";
import axios from "axios";

function UserRegisterAdmin({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact_no: "",
    signup_source: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const ContactUserRegistration = async () => {
    const payload = {
      name: formData.name,
      email: formData.email,
      mobile: `+91${formData.contact_no}`,
      signup_source: formData.signup_source,
      isAdmin :'true'
    };

    try {
      setLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/contact-user-registration/register/`,
        payload,
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      alert("User Registered Successfully!");
      console.log(response.data);

      onClose();
    } catch (error) {
      console.error(error.response?.data || error.message);
      alert("Registration Failed");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-xl font-bold"
        >
          ×
        </button>

        <h2 className="text-2xl font-semibold mb-5">
          User Registration
        </h2>

        <div className="space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Enter Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
          />

          <input
            type="email"
            name="email"
            placeholder="Enter Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
          />

          <input
            type="tel"
            name="contact_no"
            placeholder="Enter Mobile Number"
            maxLength={10}
            value={formData.contact_no}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
          />

          <input
            type="text"
            name="signup_source"
            placeholder="Signup Source"
            value={formData.signup_source}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
          />

          <button
            onClick={ContactUserRegistration}
            disabled={loading}
            className="w-full bg-[#019c81] text-white py-2 rounded-md"
          >
            {loading ? "Registering..." : "Register"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserRegisterAdmin;